import React, { useEffect, useState, useContext } from "react"
import { Container, Section } from "../grid/grid"
import { useMutation } from "@apollo/react-hooks"
import gql from "graphql-tag"
import { withFormik, Form, Field } from "formik"
import * as Yup from "yup"
import Modal from "react-modal"
import OtpInput from "react-otp-input"
import { navigate } from "gatsby"
import { LangContext } from "../../../context/LangContext"
import { submitUtm, extractCookie } from "../../../utils/handle-utm"

const importNumberForm = () => import("react-number-format")

const GET_OTP = gql`
  mutation getOtp($phoneNumber: String, $lang: String) {
    requestOtp(
      input: { clientMutationId: "", phoneNumber: $phoneNumber, lang: $lang }
    ) {
      status
      message
    }
  }
`

const GET_WA_OTP = gql`
  mutation getWAOtp($phoneNumber: String) {
    requestWAOtp(
      input: { clientMutationId: "", phoneNumber: $phoneNumber }
    ) {
      status
      message
    }
  }
`

const SUBMIT_OTP = gql`
  mutation SubmitFormInfo(
    $fullName: String
    $email: String
    $phoneNumber: String
    $otpCode: String
    $propertyName: String
    $visitDate: String
    $utm: String
  ) {
    submit2FormGetMoreInfo(
      input: {
        clientMutationId: ""
        fullName: $fullName
        email: $email
        phoneNumber: $phoneNumber
        otpCode: $otpCode
        propertyName: $propertyName
        visitDate: $visitDate
        utm: $utm
      }
    ) {
      status
      message
    }
  }
`

export const LeadForm = ({
  name,
  projectCode,
  clusterCode,
  leadSourceName,
  projectData,
  propertyTypesProject,
  contentIds,
  eCatalogProject,
  thisUrleCatalog,
}) => {
  const { lang, setLang } = useContext(LangContext)
  const [formValues, setFormValues] = useState({
    name: "",
    email: "",
    phoneNumber: "",
    visitDate: "",
  })

  const [showModal, setShowModal] = useState(false)
  const [successModal, setSuccessModal] = useState(false)
  const [otp, setOtp] = useState()
  const [otpError, setOtpError] = useState(false)
  const [timeLimit, setTimeLimit] = useState(180)
  const [NumberFormat, setNumberFormat] = useState()
  const [btn, setBtn] = useState(false)

  const [getOtp, { loading: getOtpLoading }] = useMutation(GET_OTP)
  const [getWAOtp, { loading: getWaOtpLoading }] = useMutation(GET_WA_OTP)
  const [submitOtp, { loading: submitOtpLoading }] = useMutation(SUBMIT_OTP)
  const [showOtpOptions, setShowOtpOptions] = useState(true)
  const [OtpOption, setOtpOption] = useState('sms')

  useEffect(() => {
    importNumberForm().then(component => setNumberFormat(component))
  }, [])

  useEffect(() => {
    let timer = setTimeout(() => {
      if (timeLimit >= 0 && showModal) {
        setTimeLimit(timeLimit - 1)
      }
    }, 1000)
    return () => {
      clearTimeout(timer)
    }
  }, [timeLimit, showModal])

  const NFComponent = NumberFormat && NumberFormat.default

  const formatTimeLeft = time => {
    let minutes = Math.floor(time / 60)
    let seconds = time % 60
    if (seconds < 10 && seconds >= 0) {
      seconds = `0${seconds}`
    } else if (seconds < 0) {
      seconds = "00"
    }

    if (minutes < 10 && minutes >= 0) {
      minutes = `0${minutes}`
    } else if (minutes < 0) {
      minutes = "00"
    }
    return `${minutes}:${seconds}`
  }

  const changeNullToBeZero = val => {
    if (val == null) return 0
    return val
  }

  const setDataLayerValue = event => {
    const value = {
      event: event,
      page_url: window.location.href,
      page_title: name,
      content_type: "home_listing",
      content_ids: contentIds,
      city: "bsd-city",
      region: "bsd-city",
      country: "Indonesia",
      lease_start_date: "2021-01-01",
      lease_end_date: "2100-01-01",
      currency: "IDR",
      preferred_price_range: [
        projectData?.projectCustomfields?.preferredPriceRangeFrom,
        projectData?.projectCustomfields?.preferredPriceRangeTo,
      ],
      preferred_baths_range: [
        changeNullToBeZero(
          projectData?.projectCustomfields?.preferredBathsRangeFrom
        ),
        changeNullToBeZero(
          projectData?.projectCustomfields?.preferredBathsRangeTo
        ),
      ],
      preferred_bed_range: [
        changeNullToBeZero(
          projectData?.projectCustomfields?.preferredBedRangeFrom
        ),
        changeNullToBeZero(
          projectData?.projectCustomfields?.preferredBedRangeTo
        ),
      ],
      property_type: propertyTypesProject,
    }
    return value
  }

  const setDetailDevelopmentDataLayer = value => {
    window.dataLayer = window.dataLayer || []
    window.dataLayer.push(value)
  }

  function validateEmail(value) {
    let error
    if (!value) {
      error = "Required"
    } else if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(value)) {
      error = "Invalid email address"
    }
    return error
  }

  const LeadForm = ({ errors, touched, values, setFieldValue, btnLoading }) => {
    const phoneNumberHandler = (val, setFieldValue) =>
      setFieldValue("phoneNumber", val)

    return (
      <Form>
        <div className="form-group">
          <label className="my-0">
            {lang === "EN" ? "Your Name" : "Nama Anda"}
          </label>
          <Field
            name="name"
            className="form-control"
            placeholder={
              lang == "EN" ? "Enter your name" : "Masukkan nama kamu"
            }
            type="text"
          />
          {touched.name && errors.name && (
            <div className="invalid-value d-block">{errors.name}</div>
          )}
        </div>
        <div className="form-group">
          <label className="my-0">
            {lang === "EN" ? "Your Email" : "Email Anda"}
          </label>
          <Field
            name="email"
            className="form-control"
            placeholder={
              lang == "EN" ? "Enter your email" : "Masukkan email kamu"
            }
            type="text"
            validate={validateEmail}
          />
          {touched.email && errors.email && (
            <div className="invalid-value d-block">{errors.email}</div>
          )}
        </div>

        {NFComponent && (
          <div className="form-group">
            <label className="my-0">
              {lang === "EN" ? "Phone Number" : "Nomor Telepon"}
            </label>
            <NFComponent
              name="phoneNumber"
              className="form-control"
              placeholder={
                lang == "EN"
                  ? "Enter your phone number"
                  : "Masukkan nomor telepon"
              }
              allowEmptyFormatting
              prefix="+62"
              value={values.phoneNumber}
              onValueChange={val =>
                phoneNumberHandler(val.formattedValue, setFieldValue)
              }
            />
            {touched.phoneNumber && errors.phoneNumber && (
              <div className="invalid-value d-block">{errors.phoneNumber}</div>
            )}
          </div>
        )}
        <div className="form-group">
          <label className="my-0">
            {lang === "EN" ? "Book my Appointment" : "Tanggal Kunjungan"}
          </label>

          <Field
            name="visitDate"
            className="form-control"
            placeholder={lang === "EN" ? "site visit" : "kunjungan"}
            type="date"
            min={new Date().toISOString().split("T")[0]}
          />
          {touched.visitDate && errors.visitDate && (
            <div className="invalid-value d-block">{errors.visitDate}</div>
          )}
        </div>

        <div className="form-group">
          <div className="d-flex flex-row align-items-center">
            <Field type="checkbox" name="agreement" />
            <span className="agreement ml-2">
              <a href="/privacy-policy/" target="_blank">
                {lang === "EN"
                  ? "I agree to the terms and conditions that apply.*"
                  : "Saya setuju dengan syarat & ketentuan yang berlaku.*"}
              </a>
            </span>
          </div>
          {touched.agreement && errors.agreement && (
            <div className="invalid-value d-block">{errors.agreement}</div>
          )}
        </div>

        <div className="form-group">
          <button className="btn btn-secondary btn-block">
            {btnLoading ? (
              <i className="fa fa-spinner fa-spin"></i>
            ) : (
              <>
                {lang == "EN" ? "Submit" : "Kirim"}{" "}
                <i className="fas fa-arrow-right ml-1"></i>{" "}
              </>
            )}
          </button>
          <p className="pt-3 text-muted">
            {lang == "EN"
              ? "BSD City will never sell or share your information with a third party"
              : "BSD City tidak akan pernah menjual atau membagikan informasi Anda kepada pihak ketiga"}
          </p>
        </div>
      </Form>
    )
  }

  const handleOtp = otp => {
    setOtp(otp)
  }

  const getOtpHandler = () => {
    if(OtpOption==='wa'){
      getWAOtp({
        variables: {
          phoneNumber: formValues.phoneNumber.split("+").join(""),
        },
      }).then(res => {
        if (res.data.requestWAOtp.status === "success") {
          setTimeLimit(180)
          setShowModal(true)
        }
      })
    }else{
      getOtp({
        variables: {
          phoneNumber: formValues.phoneNumber.split("+").join(""),
          lang: lang,
        },
      }).then(res => {
        if (res.data.requestOtp.status === "success") {
          setTimeLimit(180)
          setShowModal(true)
        }
      })
    }
  }

  const sendOtp = () => {
    const formatNumber = formValues.phoneNumber.split("+").join("")

    console.log('sendOtp-1: ', formatNumber)
    submitOtp({
      variables: {
        fullName: formValues.name,
        email: formValues.email,
        phoneNumber: formatNumber,
        visitDate: formValues.visitDate,
        otpCode: otp,
        propertyName: name,
        utm: extractCookie("utm_params=")
          ? JSON.stringify(extractCookie("utm_params="))
          : null,
      },
    }).then(res => {
      if (res.data.submit2FormGetMoreInfo.status === "success") {
        console.log('sendOtp-3: ', btn)
        setDetailDevelopmentDataLayer(setDataLayerValue("InitiateCheckout"))
        setBtn(true)
        setTimeout(() => {
          console.log('sendOtp-4: ', formValues)
          setShowModal(false)
          // setSuccessModal(true)
          setTimeLimit(180)
          setFormValues({
            name: "",
            email: "",
            phoneNumber: "",
            visitDate: "",
          })
          setOtp("")
          setShowOtpOptions(true)
          setOtpOption('sms')
          navigate(`/thankyou`)
        }, 1500)

        if (otpError) {
          setOtpError(false)
        }
        // send data to CPI
        if (true) {
          submitUtm({
            fullname: formValues.name,
            email: formValues.email,
            mobile: formValues.phoneNumber,
            project_name: name,
            projects_code: projectCode,
            cluster_code: clusterCode,
            lead_source_name: leadSourceName,
            visitDate: formValues.visitDate,
            web: "bsdcity.com",
          })
        }
      } else {
        setOtpError(true)
      }
    })
  }

  const EnhancedLeadForm = withFormik({
    mapPropsToValues({ name, phoneNumber, email, agreement, visitDate }) {
      return {
        name: formValues.name || name,
        email: formValues.email || email,
        phoneNumber: formValues.phoneNumber || phoneNumber,
        agreement: formValues.agreement || agreement,
        visitDate: formValues.visitDate || visitDate,
      }
    },
    validationSchema: Yup.object().shape({
      name: Yup.string().required(
        `${lang == "EN" ? "Name is required" : "Nama harus di isi"}`
      ),
      email: Yup.string().required(
        `${lang == "EN" ? "Email is required" : "Email harus di isi"}`
      ),
      phoneNumber: Yup.string().required(
        `${
          lang == "EN"
            ? "Phone number is required"
            : "Nomor telepon harus di isi"
        }`
      ),
      agreement: Yup.boolean()
        .oneOf(
          [true],
          `${lang == "EN" ? "Agreement is required" : "Agreement harus di isi"}`
        )
        .required(
          `${lang == "EN" ? "Agreement is required" : "Agreement harus di isi"}`
        ),
      visitDate: Yup.string().required("Visit date is required"),
    }),
    handleSubmit(values) {
      setFormValues(values)
      /* const formatNumber = values.phoneNumber.split("+").join("")
      getOtp({ variables: { phoneNumber: formatNumber, lang: lang } }).then(
        res => {
          if (res.data.requestOtp.status === "success") {
            setShowModal(true)
          }
        }
      )
      getWAOtp({
        variables: {
          phoneNumber: formatNumber
        },
      }).then(res => {
        console.log('res', res)
        if (res.data.requestWAOtp.status === "success") {
          console.log('WA Send')
          setShowModal(true)
        }
      }) */
      setShowModal(true)
    },
  })(LeadForm)

  const customStyles = {
    content: {
      top: "50%",
      left: "50%",
      right: "auto",
      bottom: "auto",
      marginRight: "-50%",
      transform: "translate(-50%, -50%)",
    },
  }

  const handleModal = () => {
    showOtpOptions(true)
    setOtpOption('sms')
    setShowModal(!showModal)
  }
  const handleSuccessModal = () => {
    if (thisUrleCatalog !== "#") {
      window.open(thisUrleCatalog, "_blank")
    } else {
      window.location.reload()
    }
    setSuccessModal(false)
    setBtn(false)
    setDetailDevelopmentDataLayer(setDataLayerValue("Purchase"))
  }

  const handleGetWAOtp = () => {
    const formatNumber = formValues.phoneNumber.split("+").join("")
    getWAOtp({
      variables: {
        phoneNumber: formatNumber
      },
    }).then(res => {
      if (res.data.requestWAOtp.status === "success") {
        setOtpOption('wa')
        setShowOtpOptions(false)
      }
    })
  }
  const handleGetSMSOtp = () => {
    const formatNumber = formValues.phoneNumber.split("+").join("")
    getOtp({ variables: { phoneNumber: formatNumber, lang: lang } }).then(
      res => {
        if (res.data.requestOtp.status === "success") {
          setOtpOption('sms')
          setShowOtpOptions(false)
        }
      }
    )
  }

  return (
    <>
      <Section className="sc-lead-form bg-light">
        <Container>
          <div className="row">
            <div className="col-md-6">
              <h2>
                {lang == "EN"
                  ? "Get More Information"
                  : "Dapatkan Informasi Lebih Lanjut"}
              </h2>
              <p>
                {lang == "EN"
                  ? "Visit our Marketing Gallery to view interactive models and get more information about this property."
                  : "Kunjungi Galeri Pemasaran kami untuk melihat model interaktif dan dapatkan informasi lebih lanjut tentang properti ini."}
              </p>
            </div>
            <div className="col-md-6">
              {NFComponent && <EnhancedLeadForm btnLoading={getOtpLoading || getWaOtpLoading} />}
            </div>
          </div>
        </Container>
      </Section>
      <Modal
        isOpen={showModal}
        onRequestClose={handleModal}
        style={customStyles}
        contentLabel="campaign modal"
      >
        <div className="modal-otp modal-body">
          <div className="container">
            {showOtpOptions ? (
              <div className="modal-content pl-0 pr-0 text-center">
                <h2>Choose OTP Mode</h2>
                <div className="mt-4">
                  <div className="mb-3">
                    <button 
                      onClick={() => handleGetWAOtp()} 
                      disabled={getOtpLoading || getWaOtpLoading}
                      className={`btn btn-secondary btn-block ${getOtpLoading||getWaOtpLoading?'disabled':''}`}
                    >
                      {getOtpLoading||getWaOtpLoading ? (
                        <i className="fa fa-spinner fa-spin"></i>
                      ):(
                        <i class="fab fa-whatsapp"></i>
                      )}{' '}
                      Whatsapp
                    </button>
                    <span className="text-muted">
                      <i class="fas fa-info-circle"></i> The OTP will be sent via WhatsApp number.
                    </span>
                  </div>
                  <div>
                    <button 
                      onClick={() => handleGetSMSOtp()} 
                      disabled={getOtpLoading || getWaOtpLoading}
                      className={`btn btn-outline-secondary btn-block ${getOtpLoading||getWaOtpLoading?'disabled':''}`}
                    >
                      {getOtpLoading||getWaOtpLoading ? (
                        <i className="fa fa-spinner fa-spin"></i>
                      ):(
                        <i class="far fa-envelope"></i>
                      )}{' '}
                      SMS
                    </button>
                    <span className="text-muted">
                      <i class="fas fa-info-circle"></i> The OTP will be sent via SMS.
                    </span>
                  </div>
                </div>
              </div>
            ) : (
              <div className="modal-content pl-0 pr-0">
                <h2>OTP</h2>
                <p>
                  {lang == "EN"
                    ? "To proceed, please enter the 4-digit OTP code sent to your mobile number"
                    : "Untuk melanjutkan, masukkan 4 angka kode OTP yang dikirimkan ke nomor telepon anda"}{" "}
                  <span className="font-weight-bold">
                    {" "}
                    {formValues.phoneNumber}{" "}
                  </span>
                </p>
                <OtpInput
                  value={otp}
                  containerStyle="otp-container mb-3"
                  inputStyle={`otp-input ${otpError ? "error" : ""}`}
                  onChange={handleOtp}
                  numInputs={4}
                  isInputNum={true}
                />
                <div className="modal-text">
                  {otpError && (
                    <p className="otp-error text-danger text-center">
                      {lang == "EN"
                        ? "The code you entered does not match, please re-enter."
                        : "Kode yang Anda masukkan tidak cocok, silakan masukkan kembali."}
                    </p>
                  )}
                  {getOtpLoading || getWaOtpLoading ? (
                    <p className="mt-2 text-primary text-center">
                      <i className="fa fa-spinner fa-spin"></i>
                    </p>
                  ) : timeLimit > 0 ? (
                    <p className="text-muted text-center font-weight-bold">
                      {lang == "EN"
                        ? "Haven’t received OTP code?"
                        : "Belum menerima kode OTP?"}{" "}
                      <span className="font-weight-extrabold">
                        {lang == "EN" ? "Resend" : "Kirim Ulang"}
                      </span>{" "}
                      ({timeLimit})
                    </p>
                  ) : (
                    <p
                      className="text-blue text-center font-weight-bold pointer"
                      onClick={getOtpHandler}
                    >
                      {lang == "EN"
                        ? "Haven’t received OTP code?"
                        : "Belum menerima kode OTP?"}{" "}
                      <span className="font-weight-extrabold">
                        {lang == "EN" ? "Resend" : "Kirim Ulang"}
                      </span>
                    </p>
                  )}
                </div>
                <button
                  className={`btn btn-secondary btn-block ${btn && "disabled"}`}
                  onClick={sendOtp}
                  disabled={
                    (submitOtpLoading && "disabled") || (btn && "disabled")
                  }
                >
                  {submitOtpLoading ? (
                    <i className="fa fa-spinner fa-spin"></i>
                    ) : (
                    <>
                      {" "}
                      {lang == "EN" ? "Submit" : "Kirim"}{" "}
                      <i className="fas fa-arrow-right ml-1"></i>{" "}
                    </>
                  )}
                </button>
              </div>
            )}
          </div>
        </div>
      </Modal>
      <Modal
        isOpen={successModal}
        onRequestClose={handleSuccessModal}
        style={customStyles}
        contentLabel="campaign modal"
      >
        <div className="modal-otp modal-body text-center">
          <div className="container">
            <div className="modal-content pl-0 pr-0">
              {/* <img alt="success" src={icSuccess} className="mw-25 mb-4" /> */}
              <h2>{lang == "EN" ? "OTP Verified!" : "Otp Terverifikasi"}</h2>
              <p>
                {lang == "EN"
                  ? "Your data has been submitted. Our BSD CITY team will reach out to you."
                  : "Data Anda telah dikirim. Tim BSD CITY akan menghubungi Anda."}
              </p>
              <button
                className="btn btn-secondary"
                onClick={handleSuccessModal}
              >
                {lang == "EN" ? "Visit e-Catalog" : "Kunjungi e-Catalog"}{" "}
                <i className="fas fa-arrow-right ml-1"></i>{" "}
              </button>
            </div>
          </div>
        </div>
      </Modal>
    </>
  )
}
